import React, { createContext, useState, useCallback, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { useIsInventoryEnabled } from '../../../hooks/inventory';
import { useNumberOfShipFroms } from '../../../hooks/shipFrom';
import getColumns from '../index';
import { MarkAsShippedContext } from '../../../context';

export const ColumnContext = createContext();

export const ColumnContextProvider = ({ children }) => {
  const isInventoryEnabled = useIsInventoryEnabled();
  const numberOfShipFroms = useNumberOfShipFroms();
  const { shouldForceShipFrom } = useContext(MarkAsShippedContext);
  const shouldIncludeInventory = isInventoryEnabled && numberOfShipFroms > 0;
  const [columns, setColumns] = useState(getColumns(shouldIncludeInventory, shouldForceShipFrom));

  const onColumnsChange = useCallback((cols) => setColumns(cols), [setColumns]);

  const value = useMemo(
    () => ({
      columns,
      onColumnsChange,
    }),
    [columns, onColumnsChange],
  );

  return <ColumnContext.Provider value={value}>{children}</ColumnContext.Provider>;
};

ColumnContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default ColumnContextProvider;
